import { useCallback, useEffect, useState } from "react";
import { AddressForm } from "./AddressForm";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import { FormInstance, Row } from "antd";

type ToggleAlternateAddressProps = {
  hasAlternateAddress: boolean;
  statesList: any[];
  selectedItemId: string;
  form: FormInstance;
};

export const ToggleAlternateAddress = ({
  hasAlternateAddress,
  statesList,
  selectedItemId,
  form,
}: ToggleAlternateAddressProps) => {
  const [isAddAlternateAddress, setIsAddAternateAddress] =
    useState<boolean>(false);

  useEffect(() => {
    setIsAddAternateAddress(hasAlternateAddress);
  }, [hasAlternateAddress]);

  const toggleAlternate = useCallback((): void => {
    setIsAddAternateAddress(!isAddAlternateAddress);
  }, [isAddAlternateAddress]);

  return !isAddAlternateAddress ? (
    <p
      className="my-0 text-sm w-500 card-header logo-cursor"
      onClick={toggleAlternate}
    >
      + Alternate Address
    </p>
  ) : (
    <>
      <Row className="align-center logo-cursor mb-4" onClick={toggleAlternate}>
        <DownOutlined className="mr-1" />
        Alternate Address
        <CloseOutlined className="ml-2" />
      </Row>
      <AddressForm
        propName="alternativeAddress"
        statesList={statesList}
        selectedItemId={selectedItemId}
        form={form}
      />
    </>
  );
};
